module.exports = __webpack_public_path__ + "img/tw.e3d4e8b9.svg";